import { Box, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import PolicyList from "./PolicyDetailsList";
import AppDialog from "@crema/core/AppDialog";
import AddPolicyForm from "./AddPolicyDetails";
import AppGridContainer from "@crema/core/AppGridContainer";
import { Fonts } from "shared/constants/AppEnums";
import { useDispatch } from "react-redux";
import { getPoliciesManualsItem } from "redux/actions/Policies";
import { useParams } from "react-router-dom";
import { useAuthUser } from "@crema/utility/AuthHooks";
import { RoutePermittedRole } from "shared/constants/AppConst";

export default function PoliciesDetails() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { user } = useAuthUser();
    const [open, setOpen] = useState(false);
    const [action, setAction] = useState({ add: false, edit: false });
    const [editRow, setEditRow] = useState("");
    const addHandler = () => {
        setAction({ add: true, edit: false });
        setOpen(true);
    };
    useEffect(() => {
        dispatch(getPoliciesManualsItem(id, "POLICY"));
    }, []);
    return (
        <AppGridContainer>
            <Grid item xs={12}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                    }}
                >
                    <Box
                        component="h2"
                        variant="h2"
                        sx={{
                            fontSize: 16,
                            color: "text.primary",
                            fontWeight: Fonts.SEMI_BOLD,
                        }}
                    >
                        Policies
                    </Box>
                    {user.role === RoutePermittedRole.ADMIN ||user.role === RoutePermittedRole.SUPER_ADMIN && (
                        <Box>
                            <Button variant="contained" onClick={addHandler}>
                                Add
                            </Button>
                        </Box>
                    )}
                </Box>
                <PolicyList
                    setOpen={setOpen}
                    setAction={setAction}
                    setEditRow={setEditRow}
                />
                <AppDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    title={action.add === true ? "Add" : "Update"}
                >
                    <AddPolicyForm
                        action={action}
                        setOpen={setOpen}
                        editRow={editRow}
                    />
                </AppDialog>
            </Grid>
        </AppGridContainer>
    );
}
